import { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker'
import { useQuery } from '@tanstack/react-query';
import { CalendarSVG, LoaderSVG } from '../SVGs/CommonSVG';
import Modal from '../Modal';
import FormLabel from '../Forms/FormLabel';
import GradientButton from '../Forms/GradientButton';
import GradientBorderButton from '../Forms/GradientBorderButton';
import SearchInput from '../Forms/SearchInput';
import CustomSelect from '../CustomSelect';
import { AdminCampaignAPI, CategoryAPI } from '@/Utils/APIRequest/Endpoints';
import CustomFetch from '@/Utils/APIRequest/AxiosInstance';
import Loader from '@/Layout/Loader';
import BorderButton from '../Forms/BorderButton';
import Select from 'react-select';
import { useTranslation } from '@/Utils/Hooks/useTranslate';

const ExportModal = (props) => {
    const { loader, modal, setModal, callbackFunction, categoryId, setCategoryId, categoryProps = false, statusProps = false, industryProps = false, paymentStatusProps = false, subscriptionStatusProps = false, campaignProps = false, paymentStatus, setPaymentStatus, campaignId, setCampaignId, status, setStatus, dateRange, setDateRange, customDropDownValue = null, exportSearch, setExportSearch, headerTitle, subscriptionStatus, setSubscriptionStatus } = props

    const [startDate, endDate] = dateRange;
    const dropDownValue = customDropDownValue ? customDropDownValue : ["Active", "In-Active"]
    const paymentDropDownValue = customDropDownValue ? customDropDownValue : ["credited", "debited"]
    const subscriptionDropDownValue = customDropDownValue ? customDropDownValue : ["pending", "active", "incomplete", "canceled"]
    const { translations, locale } = useTranslation();

    const [campaignSearch, setCampaignSearch] = useState('')

    useEffect(() => {
        setExportSearch("")
    }, [])

    // API Category GET
    const { data: CategoryAPIData, isPending, refetch } = useQuery({ queryKey: [CategoryAPI, locale], queryFn: () => CustomFetch({ url: CategoryAPI, params: { page: 1, per_page: 50, sort_by: "title", sort: "ASC" } }, null, false), enabled: (categoryProps || industryProps) ? true : false, refetchOnWindowFocus: false, select: (data) => data?.data?.data })

    // API Campaign GET
    const { data: CampaignAPIData, isPending: campaignIsPending, fetchStatus: campaignFetchStatus, isFetching: campaignIsFetching, refetch: campaignRefetch } = useQuery({ queryKey: [AdminCampaignAPI, campaignSearch], queryFn: () => CustomFetch({ url: AdminCampaignAPI, params: { page: 1, per_page: 50, sort_by: "created_at", sort: "DESC", search: campaignSearch } }, null, false), enabled: paymentStatusProps ? true : false, refetchOnWindowFocus: false, select: (data) => data?.data?.data })

    const CampaignList = CampaignAPIData?.map((campaign) => ({
        label: campaign?.campaign_name,
        value: campaign?.id
    }));

    const sendObj = {
        dateRange, status, paymentStatus, categoryId, campaignId, exportSearch
    }

    // Refetch API when search changes (debounced for better performance)
    useEffect(() => {
        const debounceTimer = setTimeout(() => {
            campaignRefetch();
        }, 1200); // Debounce input to reduce API calls

        return () => clearTimeout(debounceTimer);
    }, [campaignSearch]);


    const statusHandler = (event) => {
        const { value, name } = event.target
        setStatus && setStatus(value)
    }
    const categoryHandler = (event) => {
        setCategoryId && setCategoryId(event.target.value)
    }

    const paymentStatusHandler = (event) => {
        const { value, name } = event.target
        setPaymentStatus && setPaymentStatus(value)
    }

    const subscriptionStatusHandler = (event) => {
        const { value, name } = event.target
        setSubscriptionStatus && setSubscriptionStatus(value)
    }

    const campaignHandler = (event) => {
        setCampaignId && setCampaignId(event.target.value)
    }

    if (isPending && campaignIsPending) {
        return <Loader />
    }

    return (
        <Modal modalSize="md:w-2/4 xl:w-1/3 2xl:w-1/4" modal={modal} setModal={setModal} headerTitle={headerTitle} childMainClass='!overflow-visible'>
            <div className='flex-1 '>
                <div className="flex gap-3">
                    {categoryProps && <div className='mb-4 flex flex-col gap-2 items-start w-full'>
                        <FormLabel title={'Select Category'} customClass='whitespace-nowrap !mb-0 mr-3 !text-base' />
                        <div className='w-full relative max-md:mt-2'>
                            <CustomSelect selectProps={{ value: categoryId }} callBack={categoryHandler} customClass='2xl:pr-9 pr-7 py-4 !text-sm !w-full truncate max-md:mt-2 capitalize border-lightGray' >
                                {
                                    CategoryAPIData?.length > 0 ?
                                        <>
                                            <option value={""} className='text-gray-20'>All</option>
                                            {CategoryAPIData?.filter(category => category != null && !category.is_hidden)?.map((category) => (
                                                <option key={category?.id} value={category?.id} className='capitalize'>{category?.translations?.[0]?.title}</option>
                                            ))}
                                        </>
                                        : <option value={""}>{translations.noDataFound}</option>
                                }
                            </CustomSelect>
                        </div>
                    </div>}
                    {industryProps && <div className='mb-4 flex flex-col gap-2 items-start w-full'>
                        <FormLabel title={'Select Industry'} customClass='whitespace-nowrap !mb-0 mr-3 !text-base' />
                        <div className='w-full relative max-md:mt-2'>
                            <CustomSelect selectProps={{ value: categoryId }} callBack={categoryHandler} customClass='2xl:pr-9 pr-7 py-4 !text-sm !w-full truncate max-md:mt-2 capitalize border-lightGray' >
                                {
                                    CategoryAPIData?.length > 0 ?
                                        <>
                                            <option value={""} className='text-gray-20'>All</option>
                                            {CategoryAPIData?.filter(category => category != null && !category.is_hidden)?.map((category) => (
                                                <option key={category?.id} value={category?.id} className='capitalize'>{category?.translations?.[0]?.title}</option>
                                            ))}
                                        </>
                                        : <option value={""}>{translations.noDataFound}</option>
                                }
                            </CustomSelect>
                        </div>
                    </div>}
                    {statusProps && <div className='mb-4 flex flex-col gap-2 items-start w-full'>
                        <FormLabel title={'Select Status'} customClass='whitespace-nowrap !mb-0 mr-3 !text-base' />
                        <div className='w-full relative max-md:mt-2'>
                            <CustomSelect selectProps={{ value: status }} callBack={statusHandler} customClass='2xl:pr-9 pr-7 py-4 !text-sm truncate max-md:mt-2 capitalize border-lightGray w-full' >
                                {
                                    dropDownValue?.length > 0 ?
                                        <>
                                            <option value={""} className='text-gray-20'>All</option>
                                            {dropDownValue?.map((elem, index) => (
                                                <option key={index} value={elem} className='capitalize'>{elem}</option>
                                            ))}
                                        </>
                                        : <option value={""}>{translations.noDataFound}</option>
                                }
                            </CustomSelect>
                        </div>
                        {/* <Select isMulti options={dropDownValue} value={status} onChange={levelHandleChange} className={`bg-[98%] w-full sm:text-base text-sm text-gray-900 placeholder:text-gray-700 placeholder:font-normal focus:outline-none focus:shadow-[0_0_0px_3px_rgba(165,208,255,1)] focus-visible:outline-none transition-shadow `} placeholder={`Select Status`} /> */}
                    </div>}
                    {(paymentStatusProps || campaignProps) && <div className='mb-4 flex flex-col gap-2 items-start w-full'>
                        <FormLabel title={'Select Campaign'} customClass='whitespace-nowrap !mb-0 mr-3 !text-base' />
                        <div className='w-full relative max-md:mt-2'>
                            <CustomSelect selectProps={{ value: campaignId }} callBack={campaignHandler} customClass='2xl:pr-9 pr-7 py-4 !text-sm !w-full truncate max-md:mt-2 capitalize border-lightGray' >
                                {
                                    CampaignAPIData?.length > 0 ?
                                        <>
                                            <option value={""} className='text-gray-20'>All</option>
                                            {CampaignAPIData?.map((campaign) => (
                                                <option key={campaign?.id} value={campaign?.id} className='capitalize'>{campaign?.campaign_name}</option>
                                            ))}
                                        </>
                                        : <option value={""}>{translations.noDataFound}</option>
                                }
                            </CustomSelect>

                            {/* <Select
                                name="campaign"
                                options={CampaignList}
                                className='campaign-select'
                                classNamePrefix="edit-custom-select"
                                placeholder="Select Campaign"
                                isLoading={campaignIsFetching && !campaignIsPending}
                                onChange={(selectedOptions: any) => {
                                    setCampaignId(selectedOptions ? selectedOptions?.value : ''); // Store as an array
                                }}
                                onInputChange={(inputValue) => {
                                    setCampaignSearch(inputValue); // Update search term
                                }}
                                inputValue={campaignSearch} 
                            /> */}
                        </div>
                    </div>}
                    {paymentStatusProps && <div className='mb-4 flex flex-col gap-2 items-start w-full'>
                        <FormLabel title={'Select Status'} customClass='whitespace-nowrap !mb-0 mr-3 !text-base' />
                        <div className='w-full relative max-md:mt-2'>
                            <CustomSelect selectProps={{ value: paymentStatus }} callBack={paymentStatusHandler} customClass='2xl:pr-9 pr-7 py-4 !text-sm truncate max-md:mt-2 capitalize border-lightGray w-full' >
                                {
                                    paymentDropDownValue?.length > 0 ?
                                        <>
                                            <option value={"all"} className='text-gray-20'>All</option>
                                            {paymentDropDownValue?.map((elem, index) => (
                                                <option key={index} value={elem} className='capitalize'>{elem}</option>
                                            ))}
                                        </>
                                        : <option value={""}>{translations.noDataFound}</option>
                                }
                            </CustomSelect>

                        </div>
                    </div>}

                    {subscriptionStatusProps && <div className='mb-4 flex flex-col gap-2 items-start w-full'>
                        <FormLabel title={'Select Status'} customClass='whitespace-nowrap !mb-0 mr-3 !text-base' />
                        <div className='w-full relative max-md:mt-2'>
                            <CustomSelect selectProps={{ value: subscriptionStatus }} callBack={subscriptionStatusHandler} customClass='2xl:pr-9 pr-7 py-4 !text-sm truncate max-md:mt-2 capitalize border-lightGray w-full' >
                                {
                                    subscriptionDropDownValue?.length > 0 ?
                                        <>
                                            <option value={"all"} className='text-gray-20'>All</option>
                                            {subscriptionDropDownValue?.map((elem, index) => (
                                                <option key={index} value={elem} className='capitalize'>{elem}</option>
                                            ))}
                                        </>
                                        : <option value={""}>{translations.noDataFound}</option>
                                }
                            </CustomSelect>

                        </div>
                    </div>}
                </div>

                <input type='text' className='opacity-0 absolute ' />
                <div className='mb-4 flex flex-col gap-2 items-start'>
                    <FormLabel title={'Select Date Range'} customClass='whitespace-nowrap !mb-0 mr-3 !text-base' />
                    <div className='w-full relative max-md:mt-2'>
                        <DatePicker selectsRange={true} startDate={startDate} endDate={endDate} onChange={(update) => setDateRange(update)} dateFormat={'dd MMMM YYYY'} maxDate={new Date()} className='shadow-[0_1px_4px_rgba(0,0,0,0.04)] appearance-none border border-lightGray rounded-xl w-full py-4 px-3 sm:text-base text-sm text-gray-900 font-medium placeholder:text-gray-700 placeholder:font-normal focus:outline-none focus:shadow-[0_0_0px_3px_rgba(165,208,255,1)] focus-visible:outline-none transition-shadow' />
                        <CalendarSVG customClass='absolute top-[50%] translate-y-[-50%] right-3 pointer-events-none' />
                    </div>
                </div>

                <div className="flex justify-center gap-4">
                    {/* <CustomButton customClass={'hover:bg-primary border-blue hover:text-white flex items-center'} onClick={() => callBackFilter(sendObj)}>
                        Filter
                    </CustomButton> */}
                    <BorderButton customClass='flex items-center justify-center !px-10 ' onClick={() => setModal(null)}>
                        {translations.cancel}
                    </BorderButton>
                    <GradientButton customClass={'bg-primary border-blue text-white flex items-center'} disabled={loader ? loader : false}
                        // onClick={handleExport}
                        onClick={() => callbackFunction(sendObj)}
                    >
                        {translations.exportInExcel} {loader && <LoaderSVG customClass='ml-[10px]' />}
                    </GradientButton>
                </div>
            </div>
        </Modal >
    );
}

export default ExportModal;
